import { render, staticRenderFns } from "./person-centred-care.vue?vue&type=template&id=6e65cc41&scoped=true&"
import script from "./person-centred-care.vue?vue&type=script&lang=js&"
export * from "./person-centred-care.vue?vue&type=script&lang=js&"
import style0 from "./person-centred-care.vue?vue&type=style&index=0&id=6e65cc41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e65cc41",
  null
  
)

export default component.exports